import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
//Redux
import { useDispatch } from "react-redux";
import { setComponentActive } from "../../../../reducers/userConfigSlice";
//Components
import { LuChevronDown as GoChevronDown, LuChevronUp as GoChevronUp } from "react-icons/lu";
//Styles
import "./style.css";
import { useLogout } from "../../../../hooks/useLogout";

export const BlockMenu = ({ block, menuOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const componentActive = pathname.split("/").filter(Boolean)[0];
  const [selectedButton, setSelectedButton] = useState(null);
  const buttonRefs = useRef([]);
  const activeParentId = block?.find((option) =>
    option.childs?.some((child) => child.component === componentActive),
  )?.id;
  useEffect(() => {
    setSelectedButton(activeParentId ?? null);
  }, [activeParentId]);

  const { logout: logOff, loggingOut } = useLogout();

  const handleMenu = (option) => {
    if (option.id !== selectedButton) {
      if (option.component === "logout") {
        if (!loggingOut) logOff();
      } else if (option.childs) {
        setSelectedButton(option.id);
      } else {
        const parent = block?.find((item) =>
          item.childs?.some((child) => child.component === option.component),
        );
        setSelectedButton(parent?.id ?? null);
        dispatch(setComponentActive(option.component));
        navigate("/" + option.component);
      }
    } else {
      setSelectedButton(null);
    }
  };

  const FloatingSubmenu = ({ items, callback }) => {
    return (
      <div className="floatingSubmenu">
        {items?.map((i) => (
          <div
            key={i.id || i.component || i.name}
            role="button"
            tabIndex={0}
            onClick={() => callback(i)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                callback(i);
              }
            }}
            className={
              i.component === componentActive
                ? "floatingSubmenuItem optionMenuActive"
                : "floatingSubmenuItem"
            }
            aria-pressed={i.component === componentActive}
          >
            {i.name}
          </div>
        ))}
      </div>
    );
  };

  const StaticSubmenu = ({ items, callback }) => {
    return (
      <div className="staticSubmenu">
        {items?.map((i) => (
          <div
            key={i.id || i.component || i.name}
            role="button"
            tabIndex={0}
            onClick={() => callback(i)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                callback(i);
              }
            }}
            className={
              i.component === componentActive
                ? "staticSubmenuItemActive staticSubmenuItem"
                : "staticSubmenuItem"
            }
            aria-pressed={i.component === componentActive}
          >
            <div className="subMenuSquare"></div>
            <div className="subMenuText">{i.name}</div>
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (
        ![
          "floatingSubmenuItem",
          "floatingSubmenuItemSelected",
          "staticSubmenu",
          "subMenuSquare",
          "subMenuText",
        ].includes(event.target.className)
      ) {
        //setSelectedButton(null);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  return block?.map((option) => {
    const haveSubMenuOpen =
      menuOpen && selectedButton === option.id ? "subMenuIsOpen" : "";
    const haveChildSelected =
      option.childs && option.childs.length > 0
        ? option.childs.filter((f) => f.component === componentActive)
        : [];
    const fatherComponent =
      option.childs && option.childs.length > 0
        ? option.childs[0].fatherComponent
        : "";
    const activeStyle =
      (option.component === componentActive ||
        (fatherComponent === option.component &&
          haveChildSelected.length > 0)) &&
      option.component !== ""
        ? " optionMenuActive "
        : "";
    return (
      <React.Fragment key={option.id || option.component || option.name}>
        <div
          onClick={() => handleMenu(option)}
          ref={(el) => (buttonRefs.current[option.id] = el)}
          className={
            menuOpen
              ? "optionMenuOpen " + haveSubMenuOpen + activeStyle
              : "optionMenu"
          }
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleMenu(option);
            }
          }}
          aria-label={
            option.component === "logout" && loggingOut
              ? "Cerrando sesión…"
              : option.name
          }
          aria-disabled={option.component === "logout" && loggingOut}
          aria-busy={option.component === "logout" && loggingOut}
          aria-pressed={option.component === componentActive}
        >
          <div className={menuOpen ? "" : "menuIconBig" + activeStyle}>
            {option.icon}
          </div>
          <div>
            {menuOpen &&
              (option.component === "logout" && loggingOut
                ? "Cerrando sesión…"
                : option.name)}
          </div>
          {menuOpen && option.childs && option.childs.length > 0 && (
            <span className="subMenuArrowDown">
              {selectedButton === option.id ? (
                <GoChevronUp />
              ) : (
                <GoChevronDown />
              )}
            </span>
          )}
          {!menuOpen && selectedButton === option.id && (
            <FloatingSubmenu items={option.childs} callback={handleMenu} />
          )}
        </div>
        {menuOpen && selectedButton === option.id && (
          <StaticSubmenu items={option.childs} callback={handleMenu} />
        )}
      </React.Fragment>
    );
  });
};
